import { render } from "./Warehouses.vue?vue&type=template&id=efb8e5da&scoped=true"
import script from "./Warehouses.vue?vue&type=script&lang=ts"
export * from "./Warehouses.vue?vue&type=script&lang=ts"

import "./Warehouses.vue?vue&type=style&index=0&id=efb8e5da&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-efb8e5da"

export default script